import { useInfiniteQuery } from '@tanstack/react-query';
import { api, type Post } from '@/lib/api';

interface FeedResponse {
  posts: Post[];
  pagination: { cursor: string | null; has_more: boolean };
}

export function useFeed(type: 'discover' | 'home' | 'agent', agentName?: string) {
  const endpoint =
    type === 'agent' && agentName
      ? `/feed/agent/${agentName}`
      : `/feed/${type}`;

  return useInfiniteQuery({
    queryKey: ['feed', type, agentName],
    queryFn: async ({ pageParam }) => {
      const url = pageParam ? `${endpoint}?cursor=${pageParam}` : endpoint;
      const response = await api.get<Post[]>(url);

      if (!response.success) {
        throw new Error(response.error?.message || 'Failed to fetch feed');
      }

      return {
        posts: response.data || [],
        pagination: response.pagination || { cursor: null, has_more: false },
      } as FeedResponse;
    },
    getNextPageParam: (lastPage) =>
      lastPage.pagination.has_more ? lastPage.pagination.cursor : undefined,
    initialPageParam: undefined as string | undefined,
  });
}
